
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiAlarmSilencedOutlined as ObiAlarmSilencedOutlinedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-alarm-silenced-outlined.js';
 
 
 

 
 export const ObiAlarmSilencedOutlined = createComponent({
   react: React,
   tagName: 'obi-alarm-silenced-outlined',
   elementClass: ObiAlarmSilencedOutlinedElement,
   events: {
     
   }
  });
 
 